import useTagIds from '@discover-data/stores/hooks/tagIds/useTagIds';
import { type DynamicDialogProps } from '@discover-ui/dynamicDialog';
import SearchComboBox from './searchComboBox';

export type TagFilterComboBoxProps = Omit<
  DynamicDialogProps,
  'triggerLabel' | 'dialogTitle' | 'dialogDescription' | 'children'
> & {
  category: string;
  tags: {
    category: string | null;
    title: string | null;
    id: number | null;
    disabled?: boolean;
  }[];
};

export default function TagFilterComboBox({
  category,
  tags,
  triggerProps,
  ...props
}: TagFilterComboBoxProps) {
  const [tagIds, setTagIds] = useTagIds(tags);

  const count = tagIds.length;
  const hasTagsSelected = count > 0;

  const options = tags.map(({ id, title, disabled }) => ({
    value: `${id}`,
    label: `${title}`,
    disabled,
  }));

  const renderTagLabel = () => (
    <span className="flex flex-row gap-1">
      <span>{category}</span>
      {hasTagsSelected ? (
        <>
          <strong>·</strong>
          <span>{count}</span>
        </>
      ) : null}
    </span>
  );

  const hasSearchInterface = category === 'Cuisine';

  return (
    <SearchComboBox
      category={category}
      options={options}
      setTagIds={setTagIds}
      currentTagIds={tagIds}
      triggerLabel={renderTagLabel()}
      hasSearchInterface={hasSearchInterface}
      triggerProps={triggerProps}
      {...props}
    />
  );
}
